import React, { useState, useEffect } from 'react';
import soundFile from './end.wav'; // Import your sound file
import "./countdown2.css"

function CountdownTimer2(props) {

    useEffect(() => {



        const countToDate = new Date().getTime() + props.countdown * 1000;


      
        const flipAllCards = (time) => {
          const seconds = time % 60;
          const totalMinutes = Math.floor(time / 60);
          const minutes = totalMinutes;
          const hours = Math.floor(totalMinutes / 60);
        
  
          // Now you have hours, minutes, and seconds that can go past their usual limits.
          // You can use these values to update your DOM elements as needed.
        
          // Example: Update the hours, minutes, and seconds in your DOM elements
   
          flip(document.querySelector("[data-minutes-tens2]"), Math.floor(minutes / 10));
          flip(document.querySelector("[data-minutes-ones2]"), minutes % 10);
          flip(document.querySelector("[data-seconds-tens2]"), Math.floor(seconds / 10));
          flip(document.querySelector("[data-seconds-ones2]"), seconds % 10);
        };
      
        const flip = (flipCard, newNumber) => {
          const topHalf = flipCard.querySelector(".top");
          const startNumber = parseInt(topHalf.textContent);
          if (newNumber === startNumber) return;
      
          const bottomHalf = flipCard.querySelector(".bottom");
          const topFlip = document.createElement("div");
          topFlip.classList.add("top-flip");
          const bottomFlip = document.createElement("div");
          bottomFlip.classList.add("bottom-flip");
      
          topHalf.textContent = startNumber;
          bottomHalf.textContent = startNumber;
          topFlip.textContent = startNumber;
          bottomFlip.textContent = newNumber;
      
          topFlip.addEventListener("animationstart", (e) => {
            topHalf.textContent = newNumber;
          });
          topFlip.addEventListener("animationend", (e) => {
            topFlip.remove();
          });
          bottomFlip.addEventListener("animationend", (e) => {
            bottomHalf.textContent = newNumber;
            bottomFlip.remove();
          });
          flipCard.append(topFlip, bottomFlip);
        };
      
        let previousTimeBetweenDates;
      
        const timer = setInterval(() => {

          if (!props.isRunning) {
            clearInterval(timer);
            return;
          }

          const currentDate = new Date();
          const timeBetweenDates = Math.ceil((countToDate - currentDate) / 1000);
          flipAllCards(timeBetweenDates);
      
          previousTimeBetweenDates = timeBetweenDates;
      
          if (previousTimeBetweenDates <= 0) {
            props.stopCounter2()

            clearInterval(timer);
          }
        }, 250);
      
        return () => clearInterval(timer);
      }, [props.countdown,props.isRunning]);
      


    function displayHello(){
        console.log('jelo')
    }
      
  const handleStart = () => {
    props.setCountdown(props.time * 60); // Convert minutes to seconds
    props.setIsRunning(true);
  };

  const handlePause = () => {
    props.setIsRunning(false);
  };

  const handleUnpause = () => {
    props.setIsRunning(true);
  };

  const handleReset = () => {
    props.setIsRunning(false);
    props.setCountdown(0);
    props.resetTime(0);
  };

  const formatTime = (timeInSeconds) => {
    const minutes = Math.floor(timeInSeconds / 60);
    const seconds = timeInSeconds % 60;

    return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  };

  const playSound = () => {
    const audio = new Audio(soundFile);
    audio.play();
  };


  return (
    <div className="countBody">
 
  
 
      <div class="container" style={{display:"flex",flexDirection:"column",marginTop:"50px"}}>
  

        <div className="botTitle">
        <div class="container-segment">
     
      <div class="segment">
        <div class="flip-card" data-minutes-tens2>
          <div class="top">0</div>
          <div class="bottom">0</div>
        </div>
        <div class="flip-card" data-minutes-ones2>
          <div class="top">0</div>
          <div class="bottom">0</div>
        </div>
        <div>:</div>
        <div class="flip-card" data-seconds-tens2>
          <div class="top">0</div>
          <div class="bottom">0</div>
        </div>
        <div class="flip-card" data-seconds-ones2>
          <div class="top">0</div>
          <div class="bottom">0</div>
        </div>
      </div>
    </div>
        </div>
        


   
  </div>
      
    </div>
  );
}

export default CountdownTimer2;
